// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./anchor-lines-container\"></require>\n  <anchor-lines-container mooring-id.bind=\"data.mooringId\" offer-id.bind=\"data.offerId\" review-id.bind=\"data.activeReviewId\"></anchor-lines-container>\n</template>\n";
// Exports
export default code;